import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { validateCPF } from '../hook/useValidateCpf';

export const usePersonalInfoSchema = () => {
    const { t } = useTranslation();

    // Crie o esquema diretamente dentro do hook
    const originalSchema = z.object({
      documentType: z.enum(['CPF', 'PASSPORT']),
      name: z.string({required_error:t('checkin.personalInformation.forms.errors.name')}).nonempty({
        message: t('checkin.personalInformation.forms.errors.name'),
      }),
      surname: z.string({required_error:t('checkin.personalInformation.forms.errors.surname')}).nonempty({
        message: t('checkin.personalInformation.forms.errors.surname'),
      }),
      email: z.string({required_error:t('checkin.personalInformation.forms.errors.email')}).nonempty({
        message: t('checkin.personalInformation.forms.errors.email'),
      }).email({
        message: t('checkin.personalInformation.forms.errors.formatEmail'),
      }),
      countryYouLive: z.object({
        label: z.string({required_error:t('checkin.personalInformation.forms.errors.countryYouLive')}).nonempty({
          message: t('checkin.personalInformation.forms.errors.countryYouLive'),
        }),
        value: z.string({required_error:t('checkin.personalInformation.forms.errors.countryYouLive')}).nonempty({
          message: t('checkin.personalInformation.forms.errors.countryYouLive'),
        }),
      },{required_error: t('checkin.personalInformation.forms.errors.countryYouLive')}),
      birthDate: z.string({required_error:t('checkin.personalInformation.forms.errors.birthDate')}).nonempty({
        message: t('checkin.personalInformation.forms.errors.birthDate'),
      }),
      phone: z.string({required_error:t('checkin.personalInformation.forms.errors.phone')}).nonempty({
        message: t('checkin.personalInformation.forms.errors.phone'),
      }).refine((value) => {
        if (value.startsWith('55') && value.length < 13) {
            return false;
        }
        return true;
    }, { message: t('checkin.personalInformation.forms.errors.phone') }),
    documentNumber: z.string().optional(),
    })

    const omitCountryYouLive = originalSchema.omit({countryYouLive: true});

    const schemaOmitCountryYouLive = omitCountryYouLive.superRefine((data,context) => {
      if(data.documentType === 'PASSPORT' && !data.documentNumber){
        context.addIssue({
          path: ['documentNumber'],
          code: 'custom',
          message: t('checkin.personalInformation.forms.errors.passport')
        })
      }
      if(data.documentType === 'CPF' && !data.documentNumber){
        context.addIssue({
          path: ['documentNumber'],
          code: 'custom',
          message: t('checkin.personalInformation.forms.errors.cpf')
        })
      }
      if (data.documentType === 'CPF' && data.documentNumber) {
        // Se o validateCPF retornar false, adiciona um problema ao contexto
        if (!validateCPF(data.documentNumber)) {
          context.addIssue({
            path: ['documentNumber'], // Caminho do campo com erro
            message: t('checkin.personalInformation.forms.errors.invalidCPF'), // Mensagem de erro
            code: 'custom', // Código do erro
          });
        }
      }
    }
    );

    const schema = originalSchema.superRefine((data,context) => {
      if(data.documentType === 'PASSPORT' && !data.documentNumber){
        context.addIssue({
          path: ['documentNumber'],
          code: 'custom',
          message: t('checkin.personalInformation.forms.errors.passport')
        })
      }
      if(data.documentType === 'CPF' && !data.documentNumber){
        context.addIssue({
          path: ['documentNumber'],
          code: 'custom',
          message: t('checkin.personalInformation.forms.errors.cpf')
        })
      }
      if (data.documentType === 'CPF' && data.documentNumber) {
        // Se o validateCPF retornar false, adiciona um problema ao contexto
        if (!validateCPF(data.documentNumber)) {
          context.addIssue({
            path: ['documentNumber'], // Caminho do campo com erro
            message: t('checkin.personalInformation.forms.errors.invalidCPF'), // Mensagem de erro
            code: 'custom', // Código do erro
          });
        }
      }
    }
    );

    return {schema, omitCountryYouLive:schemaOmitCountryYouLive};
  };
